/* global gapi */
import React, { useState, useEffect } from 'react';

export function GoogleAnalyticsAuth ({ accessToken, children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    gapi.analytics.ready(() => {
      const authObj = { serverAuth: { access_token: accessToken } };
      if (gapi.analytics.auth.isAuthorized()) {
        setReady(true);
      } else {
        gapi.analytics.auth.authorize(authObj);
        const authResponse = gapi.analytics.auth.getAuthResponse();
        if (!authResponse) {
          gapi.analytics.auth.on('success', () => setReady(true));
        } else {
          setReady(true);
        }
      }
    });
  }, [accessToken]);
  return (
    <>
      {ready && children}
    </>
  );
}

export default GoogleAnalyticsAuth;
